import { createRoot } from "react-dom/client";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { installChunkRecovery } from "./lib/chunk-recovery";

import { registerServiceWorker } from "./lib/pwa";

import { initInstallCapture } from "./lib/install";

initInstallCapture();
installChunkRecovery();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
